import { useContext } from 'react';
import { AppContext, UserContext, DASHBOARD } from 'commons-ui';
import useService from './useService';

const useLogin = () => {
	const { showAlert } = useContext(AppContext);
	const { loginOutsourceUser } = useContext(UserContext);
	const { sendOtp } = useService();

	const handleEmailSubmit = async (email: string) => {
		const data = await sendOtp(email);
		if (data.success) {
			showAlert(data.message ?? 'Otp sent on your email!');
			return data;
		}
		showAlert(data.error ?? 'Please enter valid email', { type: 'error' });
		return data;
	};

	const handleOtpSubmit = async (email: string, otp: number | undefined) => {
		if (!otp) {
			showAlert('Invalid Email', { type: 'error' });
		}

		const res: { success?: boolean; error?: string } = await loginOutsourceUser(
			{ email, otp: Number(otp), userMerchant: 'zupee' },
			DASHBOARD.CRM
		);
		if (!res.success) {
			showAlert(res.error ?? 'Please enter correct otp', { type: 'error' });
		}
	};

	return { handleEmailSubmit, handleOtpSubmit };
};

export default useLogin;
